const parseToAmount = (totalAmount) => {
  return totalAmount ? totalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : totalAmount;
};

export default parseToAmount;